import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FlexLayoutModule} from '@angular/flex-layout';
import {InputMaskModule} from '@ngneat/input-mask';
import {CellComponent} from './cell.component';
import {AssetsSummaryComponent} from './assets-summary.component';
import {LiabilitiesSummaryComponent} from './liabilities-summary.component';
import {GuarantorsSummaryComponent} from './guarantors-summary.component';
import {DirectorsSummaryComponent} from './directors-summary.component';
import {TrusteesSummaryComponent} from './trustees-summary.component';
import {PartnersSummaryComponent} from './partners-summary.component';
import {MembersSummaryComponent} from './members-summary.component';
import {SoletradersSummaryComponent} from './soletraders-summary.component';
import {AssetFinanceSummaryComponent} from './asset-finance-summary.component';
import {BusinessFinanceSummaryComponent} from './business-finance-summary.component';
import {BusinessOverdraftSummaryComponent} from './business-overdraft-summary.component';
import {InsurancePremiumSummaryComponent} from './insurance-premium-summary.component';
import {PrimaryContactSummaryComponent} from './primary-contact-summary.component';
import {ContactsSummaryComponent} from './contacts-summary.component';
import {EntitiesSummaryComponent} from './entities-summary.component';
import {ReferencesSummaryComponent} from './references-summary.component';
import {AngularMaterialLibraryModule} from '../../angular-material/angular-material-library.module';
import {PipeLibraryModule} from '../../pipes/pipe-library.module';
import {DirectiveLibraryModule} from '../../directives/directive-library.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        InputMaskModule,
        AngularMaterialLibraryModule,
        DirectiveLibraryModule,
        PipeLibraryModule,
        CellComponent,
        AssetsSummaryComponent,
        LiabilitiesSummaryComponent,
        DirectorsSummaryComponent,
        GuarantorsSummaryComponent,
        TrusteesSummaryComponent,
        PartnersSummaryComponent,
        MembersSummaryComponent,
        SoletradersSummaryComponent,
        PrimaryContactSummaryComponent,
        ContactsSummaryComponent,
        EntitiesSummaryComponent,
        ReferencesSummaryComponent,
        AssetFinanceSummaryComponent,
        BusinessFinanceSummaryComponent,
        BusinessOverdraftSummaryComponent,
        InsurancePremiumSummaryComponent,
    ],
    exports: [
        CellComponent,
        AssetFinanceSummaryComponent,
        BusinessFinanceSummaryComponent,
        BusinessOverdraftSummaryComponent,
        PartnersSummaryComponent,
        InsurancePremiumSummaryComponent,
    ]
})
export class ApplicationSummaryModule {

}
